export interface SalesExpenseActionTypes {
  type: SalesExpenseActions;
  payload?: any;
}

export enum SalesExpenseActions {
  CREATE_SALES_EXPENSE = "CREATE_SALES_EXPENSE",

  GET_SALES_EXPENSE_LIST = "GET_SALES_EXPENSE_LIST",
  GET_MY_SALES_EXPENSE_LIST = "GET_MY_SALES_EXPENSE_LIST",

  SET_SALES_EXPENSE_LIST = "SET_SALES_EXPENSE_LIST",
  SET_MY_SALES_EXPENSE_LIST = "SET_MY_SALES_EXPENSE_LIST",

  SET_SALES_EXPENSE_LIST_PAGE_COUNT = "SET_SALES_EXPENSE_LIST_PAGE_COUNT",
  SET_MY_SALES_EXPENSE_LIST_PAGE_COUNT = "SET_MY_SALES_EXPENSE_LIST_PAGE_COUNT",

  GET_SALES_EXPENSE_DATA_BY_ID = "GET_SALES_EXPENSE_DATA_BY_ID",

  SET_SALES_EXPENSE_DATA_BY_ID = "SET_SALES_EXPENSE_DATA_BY_ID",
  SET_MY_SALES_EXPENSE_DATA_BY_ID = "SET_MY_SALES_EXPENSE_DATA_BY_ID",

  EDIT_SALES_EXPENSE_DATA_BY_ID = "EDIT_SALES_EXPENSE_DATA_BY_ID",
  UPDATE_SALES_EXPENSE_STATUS = "UPDATE_SALES_EXPENSE_STATUS",
}
